import { useEffect, useRef, useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { FaUserGraduate } from "react-icons/fa";
import { Link, Route, Routes } from "react-router-dom";
import logo from "../src/utils/images/IqraaLogo.jpg";
import "./App.css";
import Houses from "./components/houses/Houses";
import MyDocument from "./components/pdfviewer/MyDocument";
import StudentCouncil from "./components/student-council/StudentCouncil";
import About from "./pages/About/About";
import ChairmanMessage from "./pages/About/ChairmanMessage";
import KnowUs from "./pages/About/KnowUs";
import OurJourney from "./pages/About/OurJourney";
import PrincipalMessage from "./pages/About/PrincipalMessage";
import Contact from "./pages/Contact/Contact";
import Courses from "./pages/Courses/Courses";
import Home from "./pages/Home/Home";
import LifeAtIqraa from "./pages/life-at-iqraa/LifeAtIqraa";
import Mandatory from "./pages/Mandatory/Mandatory";
import SchoolContextProvider from "./store/school-site-context";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import eduemissaryLogo from "./utils/images/eduemissary.png";

function App() {
  const [isPDFMode, setisPDFMode] = useState(false);
  const [navExpanded, setNavExpanded] = useState(false);

  const [showLoginModal, setShowLoginModal] = useState(false);

  //this ref is for outside click detection
  const navRef = useRef(null);

  // useEffect for outside click
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setNavExpanded(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("touchstart", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("touchstart", handleOutsideClick);
    };
  }, []);

  const handleLoginClick = () => {
    setShowLoginModal(true);
  };

  const handleCloseModal = () => {
    setShowLoginModal(false);
  };

  const handleContinue = () => {
    window.open("https://eduemissary.com/", "_blank");
    setShowLoginModal(false);
  };

  let website = (
    <div>
      {!isPDFMode && (
        <Navbar
          expand="lg"
          className="position-absolute w-100"
          expanded={navExpanded}
          onToggle={setNavExpanded}
          ref={navRef}
        >
          <Container>
            <Navbar.Brand>
              <Link
                to="/"
                className="navbar-brand d-flex align-items-center logo-container"
              >
                <img src={logo} alt="iqraalogo" className="logo-img" />
                <span className="mx-2 text-light lh-1 fw-semibold school-name">
                  IQRAA
                  <br />
                  PUBLIC
                  <br />
                  SCHOOL
                </span>
              </Link>
            </Navbar.Brand>
            <Navbar.Toggle
              aria-controls="basic-navbar-nav"
              className="bg-light"
            />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto justify-content-end w-100">
                <Nav.Link
                  href="/"
                  className="text-uppercase nav-hover fw-bold"
                  onClick={() => setNavExpanded(false)}
                >
                  Home
                </Nav.Link>

                <NavDropdown
                  title="ABOUT US"
                  id="about-dropdown"
                  className="text-uppercase nav-hover"
                >
                  <NavDropdown.Item
                    as={Link}
                    to="/chairman-message"
                    onClick={() => setNavExpanded(false)}
                  >
                    Chairman’s Message
                  </NavDropdown.Item>

                  <NavDropdown.Item
                    as={Link}
                    to="/principal-message"
                    onClick={() => setNavExpanded(false)}
                  >
                    Principal’s Message
                  </NavDropdown.Item>

                  <NavDropdown.Item
                    as={Link}
                    to="/know-us"
                    onClick={() => setNavExpanded(false)}
                  >
                    Know Us
                  </NavDropdown.Item>

                  <NavDropdown.Item
                    as={Link}
                    to="/our-journey"
                    onClick={() => setNavExpanded(false)}
                  >
                    Our Journey
                  </NavDropdown.Item>
                </NavDropdown>

                <NavDropdown
                  title="Academic"
                  id="about-dropdown"
                  className="text-uppercase nav-hover"
                >
                  <NavDropdown.Item
                    as={Link}
                    to="/courses"
                    onClick={() => setNavExpanded(false)}
                  >
                    Our Curriculum
                  </NavDropdown.Item>

                  <NavDropdown.Item
                    as={Link}
                    to="/student-council"
                    onClick={() => setNavExpanded(false)}
                  >
                    Student Council
                  </NavDropdown.Item>

                  <NavDropdown.Item
                    as={Link}
                    to="/houses"
                    onClick={() => setNavExpanded(false)}
                  >
                    Houses
                  </NavDropdown.Item>
                </NavDropdown>

                <Nav.Link
                  href="/life-at-iqraa"
                  className="text-uppercase nav-hover fw-bold"
                  onClick={() => setNavExpanded(false)}
                >
                  Life @IQRAA
                </Nav.Link>

                <Nav.Link
                  href="/mandatory"
                  className="text-uppercase nav-hover fw-bold"
                  onClick={() => setNavExpanded(false)}
                >
                  Mandatory
                </Nav.Link>

                <Nav.Link
                  href="/contact"
                  className="text-uppercase nav-hover fw-bold"
                  onClick={() => setNavExpanded(false)}
                >
                  Contact Us
                </Nav.Link>

                <Nav.Link
                  className="text-uppercase fw-bold student-login-link"
                  onClick={() => {
                    setNavExpanded(false);
                    handleLoginClick();
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <FaUserGraduate className="me-1" />
                  Login
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      )}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/student-council" element={<StudentCouncil />} />
        <Route path="/houses" element={<Houses />} />
        <Route path="/chairman-message" element={<ChairmanMessage />} />
        <Route path="/principal-message" element={<PrincipalMessage />} />
        <Route path="/know-us" element={<KnowUs />} />
        <Route path="/our-journey" element={<OurJourney />} />
        <Route path="/about" element={<About />} />
        <Route path="/life-at-iqraa" element={<LifeAtIqraa />} />
        <Route path="/mandatory" element={<Mandatory />} />
        <Route path="/contact" element={<Contact />} />

        <Route
          path="/affiliation.pdf"
          element={<MyDocument setisPDFMode={setisPDFMode} />}
        />
        <Route
          path="/trust.pdf"
          element={<MyDocument setisPDFMode={setisPDFMode} />}
        />
        <Route
          path="/noc.pdf"
          element={<MyDocument setisPDFMode={setisPDFMode} />}
        />
        <Route
          path="/recognition.pdf"
          element={<MyDocument setisPDFMode={setisPDFMode} />}
        />
        <Route
          path="/building.pdf"
          element={<MyDocument setisPDFMode={setisPDFMode} />}
        />
        <Route
          path="/firecertificate.pdf"
          element={<MyDocument setisPDFMode={setisPDFMode} />}
        />
        <Route
          path="/selfcertificate.pdf"
          element={<MyDocument setisPDFMode={setisPDFMode} />}
        />
        <Route
          path="/waterhealth.pdf"
          element={<MyDocument setisPDFMode={setisPDFMode} />}
        />
        <Route
          path="/fee.pdf"
          element={<MyDocument setisPDFMode={setisPDFMode} />}
        />
        <Route
          path="/academic.pdf"
          element={<MyDocument setisPDFMode={setisPDFMode} />}
        />
        <Route
          path="/smc.pdf"
          element={<MyDocument setisPDFMode={setisPDFMode} />}
        />
        <Route
          path="/pta.pdf"
          element={<MyDocument setisPDFMode={setisPDFMode} />}
        />
        <Route
          path="/result.pdf"
          element={<MyDocument setisPDFMode={setisPDFMode} />}
        />
      </Routes>

      {!isPDFMode && (
        <footer>
          <div className="container my-5">
            <div className="row d-flex justify-content-between align-items-center">
              <div className="col-md-4">
                <Link to="/contact">
                  <button
                    type="button"
                    className="btn btn-outline-success btn-lg mb-5 mb-md-4"
                  >
                    Get In Touch
                  </button>
                </Link>
                <ul className="footer-social-icons list-unstyled d-flex justify-content-between">
                  <li>
                    <a href="https://www.instagram.com/iqraapublicschool/">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        fill="#B83985FF"
                        className="bi bi-instagram"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334" />
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.facebook.com/profile.php?id=61564184425246">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        fill="#3144A2FF"
                        className="bi bi-facebook"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951" />
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.youtube.com/watch?v=KwOQrogq12U6">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        fill="#dc3545"
                        className="bi bi-youtube"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408z" />
                      </svg>
                    </a>
                  </li>
                </ul>
              </div>

              <div className="col-md-7 col-lg-6">
                <div className="d-row d-md-flex justify-content-between align-items-center">
                  <div className="col-12 col-md-6 col-lg-5 mb-5 mt-4 my-md-0">
                    <ul className="footer-navigation list-unstyled mb-0">
                      <Link
                        to="/"
                        className="text-decoration-none text-success"
                      >
                        <li className="text-uppercase fw-semibold">Home</li>
                      </Link>
                      <Link
                        to="/chairman-message"
                        className="text-decoration-none text-success"
                      >
                        <li className="text-uppercase fw-semibold">About us</li>
                      </Link>
                      <Link
                        to="/courses"
                        className="text-decoration-none text-success"
                      >
                        <li className="text-uppercase fw-semibold">Academic</li>
                      </Link>
                      <Link
                        to="/life-at-iqraa"
                        className="text-decoration-none text-success"
                      >
                        <li className="text-uppercase fw-semibold">
                          Life @IQRAA
                        </li>
                      </Link>
                      <Link
                        to="/mandatory"
                        className="text-decoration-none text-success"
                      >
                        <li className="text-uppercase fw-semibold">
                          Mandatory
                        </li>
                      </Link>
                      <Link
                        to="/contact"
                        className="text-decoration-none text-success"
                      >
                        <li className="text-uppercase fw-semibold">
                          Contact Us
                        </li>
                      </Link>
                    </ul>

                    <a
                      href="https://eduemissary.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-none text-success"
                    >
                      <p className="text-uppercase fw-semibold">
                        Student Login
                      </p>
                    </a>
                  </div>
                  <div className="col-12 col-md-6 col-lg-7">
                    <ul className="list-unstyled mb-0">
                      <li>
                        <p>
                          V & P.O. Fatehpur Taga, Distt- Faridabad, 121004,
                          Haryana, India
                        </p>
                      </li>
                      <li className="bold">
                        <p>
                          Phone Number -
                          <strong> +91 7303015715, 9958562013 </strong>
                        </p>
                      </li>
                      <li>
                        <p>
                          Email - <strong>iqraaschoolofficial@gmail.com</strong>
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <div className="container footer-bottom-content">
              <div className="copyright-text">
                © {new Date().getFullYear()} IPS. All rights reserved.
              </div>

              <div className="footer-version">
                <span>Developed By</span>

                <span className="flower-icon">❀˖°</span>

                <a
                  href="https://www.jasminefiore.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="developer-link"
                >
                  Jasmine Fiore
                </a>
              </div>
            </div>
          </div>
        </footer>
      )}

      <Modal
        show={showLoginModal}
        onHide={handleCloseModal}
        centered
        backdrop="static"
        className="edu-modal"
      >
        <Modal.Body className="text-center p-4">
          {/* Header with Powered By on RHS */}
          <div className="modal-brand">
            <div className="powered-by-text">Powered By</div>

            <img src={eduemissaryLogo} alt="EduEmissary" className="edu-logo" />
          </div>

          {/* Main Content */}
          <div className="mb-3">
            <FaUserGraduate size={55} className="text-success mb-3" />
          </div>

          <h4 className="fw-bold mb-3">Student Login</h4>

          <p className="text-muted mb-4">
            You are about to leave the IQRAA Public School website and continue
            to the EduEmissary Student Portal.
          </p>

          <div className="d-flex justify-content-center gap-3 mb-4">
            <Button variant="outline-secondary" onClick={handleCloseModal}>
              Cancel
            </Button>

            <Button variant="success" onClick={handleContinue}>
              Continue
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
  // if(isPDFMode){
  //   website = <MyDocument/>
  // }

  return <SchoolContextProvider>{website}</SchoolContextProvider>;
}

export default App;
